import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  LayoutDashboard, CalendarDays, Users, Megaphone,
  Settings, LogOut, QrCode
} from 'lucide-react';

const NAV = [
  { path: '/',          label: 'Tableau de bord', icon: LayoutDashboard },
  { path: '/events',    label: 'Événements',       icon: CalendarDays },
  { path: '/settings',  label: 'Paramètres',       icon: Settings },
];

export default function Layout() {
  const { logout, username } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = path =>
    path === '/' ? pathname === '/' : pathname.startsWith(path);

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <QrCode size={22} style={{ color: '#4f7cff', marginBottom: 6 }} />
          <span>InviteSystem</span>
          <small>Gestion événements</small>
        </div>

        <nav>
          {NAV.map(({ path, label, icon: Icon }) => (
            <div
              key={path}
              className={`nav-item ${isActive(path) ? 'active' : ''}`}
              onClick={() => navigate(path)}
            >
              <Icon size={16} />
              {label}
            </div>
          ))}
        </nav>

        <div className="sidebar-bottom">
          <div className="text-sm text-muted" style={{ marginBottom: 10 }}>
            Connecté en tant que<br />
            <strong style={{ color: 'var(--text)' }}>{username}</strong>
          </div>
          <button className="btn btn-ghost btn-sm" onClick={logout} style={{ width: '100%' }}>
            <LogOut size={14} /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
